import {
    licensesConstants,
    licensesFulfilledConstants,
    licensesPendingConstants,
    licensesRejectedConstants
} from '../actions';

const initialState = {
    items: [],
    assignedItems: [],
    numberOfAssigned: 0,
    numberOfUnAssigned: 0,
    licenseSummary: {},
    currentLicenseTypeId: 0,
    total: 0,
    loading: true,
    error: '',
};

export default function (state = initialState, action) {
    switch (action.type) {
        case licensesConstants.LICENSES_CLEARED:
            return initialState;
        case licensesConstants.LICENSE_REVIEW_CLEARED:
            return {
                ...state,
                assignedItems: []
            };
        case licensesFulfilledConstants.LICENSE_SUMMARY:
            return {
                ...state,
                licenseSummary: action.payload,
                loading: false
            };
        case licensesFulfilledConstants.LICENSES_LOADED:
            return {
                ...state,
                items: action.payload.licenses,
                total: action.payload.total,
                loading: false
            };
        case licensesFulfilledConstants.LICENSE_UNASSIGNED:
            return {
                ...state,
                numberOfUnAssigned: action.payload
            };
        case licensesFulfilledConstants.LICENSE_ASSIGNEE_USERS:
            return {
                ...state,
                assignedItems: action.payload.licenseUserAssignments,
                loading: false
            };
        case licensesFulfilledConstants.LICENSE_ASSIGNEE_DEVICES:
            return {
                ...state,
                assignedItems: action.payload.licenseVirtualMachineAssignments,
                loading: false
            };
        case licensesFulfilledConstants.LICENSE_ASSIGNEE_INFRASTRUCTURE_UNITS:
            return {
                ...state,
                assignedItems: action.payload.licenseDeviceAssignments,
                loading: false
            };

        case licensesFulfilledConstants.LICENSE_DELETED:
        case licensesFulfilledConstants.MANUFACTURER_SAVED:
        case licensesFulfilledConstants.LICENSE_CREATED:
            return {
                ...state,
                loading: false
            };
        case licensesFulfilledConstants.LICENSE_ASSIGNED:
            return {
                ...state,
                numberOfAssigned: action.payload,
                loading: false
            };

        case licensesPendingConstants.LICENSE_DELETED:
        case licensesPendingConstants.LICENSES_LOADED:
        case licensesPendingConstants.MANUFACTURER_SAVED:
        case licensesPendingConstants.LICENSE_SUMMARY:
        case licensesPendingConstants.LICENSE_ASSIGNEE_INFRASTRUCTURE_UNITS:
        case licensesPendingConstants.LICENSE_ASSIGNEE_DEVICES:
        case licensesPendingConstants.LICENSE_ASSIGNEE_USERS:
        case licensesPendingConstants.LICENSE_UNASSIGNED:
        case licensesPendingConstants.LICENSE_UPDATED:
        case licensesPendingConstants.LICENSE_CREATED:
        case licensesPendingConstants.LICENSE_ASSIGNED:
            return {
                ...state,
                loading: true
            };

        case licensesRejectedConstants.LICENSE_CREATED:
        case licensesRejectedConstants.LICENSE_ASSIGNED:
        case licensesRejectedConstants.LICENSES_LOADED:
        case licensesRejectedConstants.LICENSE_DELETED:
        case licensesRejectedConstants.LICENSE_UPDATED:
        case licensesRejectedConstants.LICENSE_UNASSIGNED:
        case licensesRejectedConstants.LICENSE_ASSIGNEE_USERS:
        case licensesRejectedConstants.LICENSE_ASSIGNEE_DEVICES:
        case licensesRejectedConstants.LICENSE_ASSIGNEE_INFRASTRUCTURE_UNITS:
        case licensesRejectedConstants.LICENSE_REVIEW_UPDATED:
        case licensesRejectedConstants.LICENSE_SUMMARY: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }

        default:
            return state;
    }
}
